import { telegramWorkflowMessageIdentity } from './workflowMessageIdentity';
import {
    Api_AutoReply,
    Api_ResetAutoReply,
    Api_AiChat,
    Api_AiOpenSession,
    Api_AiSendMessage,
    Api_AiResetSession,
    getMeta,
    Api_TgBot_Report,
    Api_AiQueryChatRsp,
    Api_AiSendChat
} from "../api";
import { Database } from "../../config/databases";
import IDBStorage from "../../lib/files/idb";
import DATABASE_STATE from "../../config/databases/state";
import rootScope from "../../lib/rootScope";
import {
    getUserNameByPeerId,
    getFullNameByPeerId,
    getSessionStorage,
    setSessionStorage,
} from "../utils/index";
import readOnlineFile from "./../utils/readFile";
import aiLogger from "./AiLogger";
import { setHasRead, setTyping } from "./../utils/pcApi";
import { getAIReplyStatus as readAIReplyStatus } from './aiReplyStatus';

const second = 3;
// 最大重试次数
const MAX_RETRIES = 3;
// 重试延迟基数（毫秒）
const RETRY_DELAY_BASE = 1000;
// 处理中的用户请求映射，防止重复处理
const processingUsers = new Map();

export interface AiReplyOptions {
    [key: string]: any;
}

// API响应接口
interface ApiResponse<T = any> {
    code: number;
    data: T;
    message?: string;
}

// 判断是否为TG官方通知账号
function isTGNotificationAccount(peerId: number): boolean {
    if (
        peerId == 777000 ||
        peerId == 429000 ||
        peerId == 333000 ||
        peerId == 42777
    ) {
        return true;
    }
    return false;
}

async function isFansOpenAi(sysType: any, sysId: any) {
    let res = await getMeta({ sysType, sysId }) as unknown as ApiResponse;
    if (res.code == 200) {
        if (res.data.aiReply == 1) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

function getAIName(userInfo: any) {
    let firstName = userInfo.first_name ?? "";
    let split = firstName.length > 0 ? " " : "";
    let lastName = userInfo.last_name ?? "";
    return firstName + split + lastName;
}

// 获取消息类型
function getTypeOfMsg(options: any): string {
    const msg = options.message;
    console.log("~~getTypeOfMsg被调用 :>> ", msg);

    if (msg._ == 'message') {
        // 如果存在media，则判断media的类型
        if (msg.media) {
            if (msg.media._ == 'messageMediaDocument') {
                if (msg.media.document.type == 'video' || msg.media.document.type == 'round') {
                    return 'video';
                } else {
                    return msg.media.document.type;
                }
            }
        }

        return 'text';
    }

    if (msg._ == 'messageService') {
        return msg.action._;  //messageActionPhoneCall
    }

    return 'text'; // 默认返回文本类型
}

// 获取消息内容
function getMessageOfMsg(options: any, type: string): string {
    const msg = options.message;

    if (type == "text") {
        return msg.message || '';
    }

    if (type == "sticker") {
        return msg.media?.document?.stickerEmojiRaw || '[贴纸]';
    }

    if (type == "messageActionPhoneCall") {
        return "[通话]";
    }

    if (type == "voice") {
        return "[语音]";
    }

    if (type == "video") {
        return "[视频]";
    }

    if (type == "round") {
        return "[视频留言]";
    }

    if (type == "gif") {
        return "[GIF动图]";
    }

    if (type == "photo") {
        return "[图片]";
    }

    return "[未知消息类型]";
}

// 将消息类型转换为API需要的格式
function translateMessageType(msgType: string): string {
    switch (msgType) {
        case 'text':
            return 'MSG_TEXT';
        case 'photo':
            return 'MSG_IMAGE';
        case 'video':
        case 'round':
            return 'MSG_VIDEO';
        case 'voice':
            return 'MSG_VOICE';
        case 'sticker':
            return 'MSG_STICKER';
        case 'gif':
            return 'MSG_GIF';
        case 'messageActionPhoneCall':
            return 'MSG_CALL';
        default:
            return 'MSG_TEXT';
    }
}

// 获取用户AI回复状态
async function getAIReplyStatus() {
    const status = readAIReplyStatus();
    return status ? parseInt(status) : 0;
}



// 使用重试机制执行异步操作
async function withRetry<T>(operation: () => Promise<T> | T, context: string, userId: number, maxRetries = MAX_RETRIES): Promise<T> {
    let lastError;
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const result = await operation();
            // 如果成功，返回结果
            return result;
        } catch (error) {
            lastError = error;
            console.error(`${context} 失败 (尝试 ${attempt}/${maxRetries}):`, error);
            aiLogger.logError(userId, error, `${context} - 尝试 ${attempt}/${maxRetries}`);

            if (attempt < maxRetries) {
                // 指数退避策略，增加每次重试的延迟
                const delay = RETRY_DELAY_BASE * Math.pow(2, attempt - 1);
                // 添加一些随机性避免所有请求同时重试
                const jitter = Math.random() * 500;
                await new Promise(resolve => setTimeout(resolve, delay + jitter));
            }
        }
    }
    // 所有重试都失败后抛出最后一个错误
    throw lastError;
}

// 防抖策略：确保同一用户的请求不会重复处理
function preventReprocessing(userId: number, timeoutMs = 5000): boolean {
    if (processingUsers.has(userId)) {
        console.log(`用户 ${userId} 的消息正在处理中，跳过重复处理`);
        return false;
    }

    processingUsers.set(userId, Date.now());
    setTimeout(() => {
        processingUsers.delete(userId);
    }, timeoutMs);

    return true;
}

// 发送文本消息给用户
function Send_text_ai(peerId: number, text: string): void {
    try {
        rootScope.managers.appMessagesManager.sendText(peerId, text);
    } catch (error) {
        console.error('发送文本消息失败:', error);
        aiLogger.logError(peerId, error, '发送文本消息');
    }
}

// 发送图片消息给用户
function Send_image_ai(peerId: number, url: string): void {
    try {
        fetch(url)
            .then(r => r.blob())
            .then(blob => {
                const file = new File([blob], "ai_image.jpg", { type: 'image/jpeg' });
                rootScope.managers.appMessagesManager.sendFile(peerId, {
                    file,
                    isMedia: true,
                    width: 800,
                    height: 600
                });
            })
            .catch(error => {
                console.error('发送图片消息失败:', error);
                aiLogger.logError(peerId, error, '发送图片消息-fetch');
            });
    } catch (error) {
        console.error('发送图片消息失败:', error);
        aiLogger.logError(peerId, error, '发送图片消息');
    }
}

async function getReplyFormAi(received_msg: any) {
    const peerId = received_msg.message.peerId;
    console.log(`~~DEBUG_LOG: getReplyFormAi开始 peerId=${peerId}`);

    try {
        const { userId, sourceMessageId } = telegramWorkflowMessageIdentity(received_msg.message);
        // 记录收到的用户消息 - 直接尝试记录，不放在try-catch中
        console.log(`~~DEBUG_LOG: 尝试记录收到的用户消息 peerId=${peerId}`);

        // 获取消息类型和内容
        let message_type = "unknown";
        let message = "";

        try {
            message_type = getTypeOfMsg(received_msg);
            message = getMessageOfMsg(received_msg, message_type);
            console.log(`~~DEBUG_LOG: 获取消息类型和内容成功 type=${message_type}, content=${message}`);
        } catch (parseError) {
            console.error(`~~DEBUG_LOG: 解析消息失败:`, parseError);
            message_type = "text";
            message = "[消息解析失败]";
        }

        let type = translateMessageType(message_type);

        // 获取用户信息
        let usernames, fullName;
        try {
            console.log(`~~DEBUG_LOG: 开始获取用户信息 peerId=${peerId}`);
            [usernames, fullName] = await Promise.all([
                withRetry(() => getUserNameByPeerId(peerId), '获取用户名', peerId),
                withRetry(() => getFullNameByPeerId(peerId), '获取用户全名', peerId)
            ]);
            console.log(`~~DEBUG_LOG: 获取用户信息成功 usernames=${usernames}, fullName=${fullName}`);
        } catch (userInfoError) {
            console.error(`~~DEBUG_LOG: 获取用户信息失败:`, userInfoError);
            usernames = "unknown";
            fullName = "未知用户";
        }

        // 强制记录日志以确认aiLogger是否工作
        console.log(`~~DEBUG_LOG: aiLogger状态:`, {
            initialized: typeof aiLogger !== 'undefined' ? (aiLogger as any).initialized : false,
            hasSessionId: typeof aiLogger !== 'undefined' && typeof (aiLogger as any).sessionId !== 'undefined',
            hasStorage: typeof aiLogger !== 'undefined' && typeof (aiLogger as any).storage !== 'undefined'
        });

        // 安全访问window全局对象
        if (typeof window !== 'undefined') {
            (window as any)._debug_logs = (window as any)._debug_logs || [];
            (window as any)._debug_logs.push({
                time: new Date().toISOString(),
                peerId,
                message_type,
                message,
                usernames,
                fullName
            });
        }

        // 记录消息到aiLogger
        try {
            console.log(`~~DEBUG_LOG: 尝试通过aiLogger记录消息`);
            aiLogger.logReceivedMessage(
                peerId,
                message,
                {
                    type: message_type,
                    translatedType: type,
                    fullName,
                    usernames
                }
            );
            console.log(`~~DEBUG_LOG: aiLogger记录消息成功`);
        } catch (logError) {
            console.error(`~~DEBUG_LOG: aiLogger记录消息失败:`, logError);

            // 尝试手动存储日志
            try {
                const storage = new IDBStorage(DATABASE_STATE, 'aiLogs');
                const logItem = {
                    timestamp: Date.now(),
                    formattedTime: new Date().toISOString(),
                    type: "RECEIVED_MESSAGE_MANUAL",
                    level: "INFO",
                    message: `收到用户 ${peerId} 的消息: ${message}`,
                    data: { manual_recovery: true }
                };

                console.log(`~~DEBUG_LOG: 尝试手动存储日志`);
                const existingLogs = await storage.get(peerId.toString()) || [];
                await storage.save(peerId.toString(), [...existingLogs, logItem]);
                console.log(`~~DEBUG_LOG: 手动存储日志成功`);
            } catch (manualLogError) {
                console.error(`~~DEBUG_LOG: 手动存储日志也失败:`, manualLogError);
            }
        }

        // 发送消息到AI服务
        console.log(`~~DEBUG_LOG: 准备发送消息到AI服务`);
        let apiResponse = null;

        try {
            const res = await withRetry(() => Api_AiSendChat({
                type: type,
                message,
                fullName,
                userName: fullName,
                userId,
                sourceMessageId,
                inviteCode: sessionStorage.getItem("tolink_inviteCode") ?? null,
                targetApp: sessionStorage.getItem("tolink_targetApp") ?? null,
                workgroupCode: sessionStorage.getItem("tolink_groupCode") ?? null,
                workgroupName: sessionStorage.getItem("tolink_groupName") ?? null,
                botId: localStorage.getItem('.tweb.botId') ?? null,
                workTgname: rootScope.myId,
                proxyUserName: JSON.parse(localStorage.getItem("user_auth") || '{}').id,
                tag: null,
                fromUser: true,
                debugStatus: "",
            }), '发送AI消息', peerId) as unknown as ApiResponse<any>;

            apiResponse = res;
            console.log(`~~DEBUG_LOG: AI服务响应成功`, res);

            setHasRead(received_msg.message);

            // 记录API成功响应
            if (typeof window !== 'undefined') {
                (window as any)._debug_logs.push({
                    time: new Date().toISOString(),
                    event: "API_SUCCESS",
                    peerId,
                    response: res
                });
            }

            if (res && res.code === 0) {
                return true;
            } else {
                console.error(`~~DEBUG_LOG: API返回错误码: ${res.code}`, res.message);
                return false;
            }
        } catch (apiError) {
            console.error(`~~DEBUG_LOG: 调用AI服务API失败:`, apiError);

            // 记录API失败
            if (typeof window !== 'undefined') {
                (window as any)._debug_logs.push({
                    time: new Date().toISOString(),
                    event: "API_FAILURE",
                    peerId,
                    error: apiError.toString()
                });
            }

            return false;
        }
    } catch (error) {
        console.error(`~~DEBUG_LOG: getReplyFormAi主函数异常:`, error);

        // 记录整体错误
        if (typeof window !== 'undefined') {
            (window as any)._debug_logs.push({
                time: new Date().toISOString(),
                event: "FATAL_ERROR",
                peerId,
                error: error.toString()
            });
        }

        return false;
    }
}

async function queryAiMsg(peerId: any, attemptNumber: number = 1) {
    console.log(`~~DEBUG_LOG: queryAiMsg开始处理，peerId=${peerId}，第${attemptNumber}次查询`);
    try {
        if (typeof window !== 'undefined') {
            (window as any)._query_logs = (window as any)._query_logs || [];
            (window as any)._query_logs.push({
                time: new Date().toISOString(),
                event: "QUERY_START",
                peerId,
                attemptNumber
            });
        }

        aiLogger.startPerformanceMetric('queryAiMsg');
        console.log("~~开始查询AI消息响应", peerId);

        // 查询AI消息响应
        console.log(`~~DEBUG_LOG: 开始调用Api_AiQueryChatRsp`);
        let res = null;
        try {
            res = await withRetry(
                () => Api_AiQueryChatRsp({ userId: peerId }),
                '查询AI消息响应',
                peerId
            ) as unknown as ApiResponse<any>;
            console.log(`~~DEBUG_LOG: Api_AiQueryChatRsp调用成功`, res);

            // 记录到内存日志
            if (typeof window !== 'undefined') {
                (window as any)._query_logs.push({
                    time: new Date().toISOString(),
                    event: "QUERY_SUCCESS",
                    peerId,
                    attemptNumber,
                    response: res
                });
            }

            // 使用新方法记录每次query_chat的响应
            try {
                aiLogger.logQueryChat(peerId, res, attemptNumber);
                console.log(`~~DEBUG_LOG: 第${attemptNumber}次query_chat响应已记录`);
            } catch (logError) {
                console.error(`~~DEBUG_LOG: 记录query_chat响应失败:`, logError);
            }
        } catch (apiError) {
            console.error(`~~DEBUG_LOG: Api_AiQueryChatRsp调用失败`, apiError);

            if (typeof window !== 'undefined') {
                (window as any)._query_logs.push({
                    time: new Date().toISOString(),
                    event: "QUERY_API_ERROR",
                    peerId,
                    attemptNumber,
                    error: apiError.toString()
                });
            }
            throw apiError; // 重新抛出让外层catch处理
        }

        aiLogger.endPerformanceMetric(peerId, 'queryAiMsg');
        console.log("~~查询AI消息响应结果", res);

        if (res && res.code == 0 || res.message == 'ai conversation in process......') {
            console.log(`~~DEBUG_LOG: 查询成功，正在处理`, res);

            // 尝试记录AI响应 (原始记录，保留兼容性)
            try {
                const responseId = `${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
                console.log(`~~DEBUG_LOG: 尝试记录AI查询响应，responseId=${responseId}`);
                aiLogger.logAiQueryResponse(peerId, {
                    id: responseId,
                    code: res.code,
                    message: res.message,
                    data: res.data,
                    attemptNumber: attemptNumber
                });
                console.log(`~~DEBUG_LOG: 记录AI查询响应成功`);
            } catch (logError) {
                console.error(`~~DEBUG_LOG: 记录AI查询响应失败`, logError);
            }

            // 处理返回的消息（现在是数组形式）
            if (res.data && Array.isArray(res.data)) {
                console.log(`~~DEBUG_LOG: 收到 ${res.data.length} 条消息，准备处理`);
                
                for (const item of res.data) {
                    if (item.type == 'MSG_TEXT') {
                        console.log(`~~DEBUG_LOG: 收到文本消息，准备发送`, item.content);
                        try {
                            aiLogger.logAiMessageSent(peerId, item.content, 'text', res);
                            Send_text_ai(peerId, item.content);
                            console.log(`~~DEBUG_LOG: 发送文本消息成功`);
                        } catch (sendError) {
                            console.error(`~~DEBUG_LOG: 发送文本消息失败`, sendError);
                        }
                    }

                    if (item.type == 'MSG_IMAGE') {
                        console.log(`~~DEBUG_LOG: 收到图片消息，准备发送`, item.content);
                        try {
                            aiLogger.logAiMessageSent(peerId, item, 'image', res);
                            Send_image_ai(peerId, item.content);
                            console.log(`~~DEBUG_LOG: 发送图片消息成功`);
                        } catch (sendError) {
                            console.error(`~~DEBUG_LOG: 发送图片消息失败`, sendError);
                        }
                    }
                }
            } else if (res.data && res.data.type) {
                // 兼容旧的单个对象格式
                console.log(`~~DEBUG_LOG: 收到单个消息（旧格式），准备处理`);
                
                if (res.data.type == 'MSG_TEXT') {
                    console.log(`~~DEBUG_LOG: 收到文本消息，准备发送`, res.data.content);
                    try {
                        aiLogger.logAiMessageSent(peerId, res.data.content, 'text', res);
                        Send_text_ai(peerId, res.data.content);
                        console.log(`~~DEBUG_LOG: 发送文本消息成功`);
                    } catch (sendError) {
                        console.error(`~~DEBUG_LOG: 发送文本消息失败`, sendError);
                    }
                }

                if (res.data.type == 'MSG_IMAGE') {
                    console.log(`~~DEBUG_LOG: 收到图片消息，准备发送`, res.data.content);
                    try {
                        aiLogger.logAiMessageSent(peerId, res.data, 'image', res);
                        Send_image_ai(peerId, res.data.content);
                        console.log(`~~DEBUG_LOG: 发送图片消息成功`);
                    } catch (sendError) {
                        console.error(`~~DEBUG_LOG: 发送图片消息失败`, sendError);
                    }
                }
            }

            // 准备下一次查询
            console.log(`~~DEBUG_LOG: 设置下一次查询定时器`);
            setTimeout(async () => {
                try {
                    console.log(`~~DEBUG_LOG: 定时器触发，继续查询AI消息`, peerId);
                    // 传递递增的查询次数
                    await queryAiMsg(peerId, attemptNumber + 1);
                } catch (error) {
                    console.error(`~~DEBUG_LOG: 定时查询AI消息失败`, error);
                    try {
                        aiLogger.logError(peerId, error, '定时查询AI消息');
                        // 传递错误信息作为结束原因
                        aiLogger.endSession(peerId, {
                            code: -1,
                            message: '定时查询失败',
                            error: error.toString(),
                            attemptNumber: attemptNumber
                        });
                    } catch (logError) {
                        console.error(`~~DEBUG_LOG: 记录定时查询错误失败`, logError);
                    }
                }
            }, second * 2000); // 错误后延时更长

            return true;
        } else {
            // AI会话结束
            console.log(`~~DEBUG_LOG: AI会话结束，code=${res.code}, message=${res.message}`);
            try {
                // 传递响应体作为结束原因，包含查询次数
                aiLogger.endSession(peerId, {
                    ...res,
                    attemptNumber: attemptNumber,
                    finalQuery: true
                });
                console.log(`~~DEBUG_LOG: endSession调用成功，包含结束原因和查询次数`);
            } catch (endError) {
                console.error(`~~DEBUG_LOG: endSession调用失败`, endError);
            }
            return false;
        }
    } catch (error) {
        console.error(`~~DEBUG_LOG: queryAiMsg整体异常`, error);

        if (typeof window !== 'undefined') {
            (window as any)._query_logs.push({
                time: new Date().toISOString(),
                event: "QUERY_FATAL_ERROR",
                peerId,
                attemptNumber,
                error: error.toString()
            });
        }

        // 即使出错，也要延迟后再尝试
        setTimeout(async () => {
            try {
                console.log(`~~DEBUG_LOG: 错误后重试查询AI消息`, peerId);
                // 传递递增的查询次数
                await queryAiMsg(peerId, attemptNumber + 1);
            } catch (retryError) {
                console.error(`~~DEBUG_LOG: 重试查询AI消息失败`, retryError);
                try {
                    aiLogger.logError(peerId, retryError, '重试查询AI消息');
                    aiLogger.endSession(peerId, {
                        code: -1,
                        message: '重试查询失败',
                        error: retryError.toString(),
                        attemptNumber: attemptNumber
                    });
                } catch (logError) {
                    console.error(`~~DEBUG_LOG: 记录重试查询错误失败`, logError);
                }
            }
        }, second * 2000); // 错误后延时更长

        return false;
    }
}

export async function initAiReply(options: AiReplyOptions) {
    const { message } = options;
    const peerId = message.peerId;

    console.log("~~initAiReply开始处理消息 :>> ", options);

    try {
        // 检查是否已在处理该用户的消息
        if (!preventReprocessing(peerId)) {
            console.log(`~~用户 ${peerId} 的消息正在处理中，跳过`);
            return;
        }

        // 尝试重新初始化AI日志系统并记录开始处理
        await aiLogger.reinitialize();

        // 强制记录日志到控制台，确保可追踪
        console.log(`~~[处理日志] 开始处理用户 ${peerId} 的消息:`, message);

        // 开始性能监控
        aiLogger.startPerformanceMetric('initAiReply_total');

        // 开始新的AI会话并记录
        aiLogger.startSession(peerId, options);
        console.log("~~已开启AI会话，准备获取回复 :>> ");

        // 记录消息类型和内容到控制台
        const msgType = getTypeOfMsg(options);
        const msgContent = getMessageOfMsg(options, msgType);
        console.log(`~~[消息内容] 类型:${msgType}, 内容:${msgContent}`);

        // 获取AI回复
        let res = await getReplyFormAi(options);
        console.log("~~getReplyFormAi处理结果 :>> ", res);

        if (res) {
            // console.log(`~~开始查询AI响应`);
            // let ai_msg_res = await queryAiMsg(peerId);

            // // 更新UI显示（如果存在）
            // try {
            //     let el = document.querySelector(
            //         `[data-peer-id="${peerId}"]`
            //     );
            //     let aibox = el?.querySelector(".ai-status-row");
            //     if (aibox) {
            //         aibox.innerHTML = `AI已启动`;
            //         console.log("~~更新AI状态UI成功");
            //     }
            // } catch (uiError) {
            //     console.error("~~更新AI状态UI失败:", uiError);
            // }

            // console.log("~~AI响应查询结果 :>> ", ai_msg_res);
        } else {
            // AI回复失败，记录会话结束
            console.log(`~~AI回复失败，结束会话`);
            aiLogger.endSession(peerId, {
                code: -1,
                message: 'AI回复失败',
                error: 'Failed to get AI reply'
            });
        }

        aiLogger.endPerformanceMetric(peerId, 'initAiReply_total', '完成AI回复全流程');
    } catch (error) {
        console.error("~~AI回复出错:", error);
        // 记录错误
        try {
            aiLogger.logError(peerId, error, 'AI回复初始化');
            aiLogger.endSession(peerId, {
                code: -1,
                message: 'AI回复初始化错误',
                error: error.toString()
            });
        } catch (logError) {
            console.error("~~记录错误日志失败:", logError);
        }
    } finally {
        // 确保处理标记最终会被清除
        setTimeout(() => {
            processingUsers.delete(peerId);
            console.log(`~~已清除用户 ${peerId} 的处理标记`);
        }, 10000);
    }
}

// 添加全局辅助函数用于调试
if (typeof window !== 'undefined') {
    (window as any).checkAiLogs = async function (peerId?: number) {
        console.log("==== AI日志系统检查开始 ====");

        // 检查aiLogger对象状态
        console.log("aiLogger状态:", {
            exists: typeof aiLogger !== 'undefined',
            initialized: typeof aiLogger !== 'undefined' ? (aiLogger as any).initialized : false,
            hasStorage: typeof aiLogger !== 'undefined' && typeof (aiLogger as any).storage !== 'undefined'
        });

        // 检查IndexedDB
        try {
            const storage = new IDBStorage(DATABASE_STATE, 'aiLogs');
            console.log("尝试直接访问日志存储");

            // 获取全部键
            try {
                // 检查storage是否有getKeys方法
                const keys = typeof storage.getKeys === 'function' ? await storage.getKeys() : [];
                console.log(`找到 ${keys.length} 个日志键`, keys);

                // 如果提供了特定peerId，获取该用户的日志
                if (peerId) {
                    try {
                        // 使用aiLogger新的会话摘要功能
                        console.log("===== 用户会话摘要 =====");
                        const sessionSummaries = await aiLogger.getSessionSummaries(peerId);
                        console.log(`找到 ${sessionSummaries.length} 个会话:`);

                        for (const summary of sessionSummaries) {
                            console.log(`
会话ID: ${summary.sessionId}
起始时间: ${new Date(summary.startTime).toLocaleString()}
结束时间: ${new Date(summary.endTime).toLocaleString()}
消息数量: ${summary.messageCount}
第一条消息: ${summary.firstMessage || '无'}
`);
                        }

                        // 如果有会话，展示第一个会话的详细信息
                        if (sessionSummaries.length > 0) {
                            const firstSessionId = sessionSummaries[0].sessionId;
                            console.log(`===== 最新会话详情 (${firstSessionId}) =====`);
                            const sessionLogs = await aiLogger.getSessionLogs(peerId, firstSessionId);

                            // 按类型统计
                            const typeCounts: Record<string, number> = {};
                            sessionLogs.forEach((log: any) => {
                                const type = log?.type || 'UNKNOWN';
                                typeCounts[type] = (typeCounts[type] || 0) + 1;
                            });
                            console.log("日志类型分布:", typeCounts);

                            // 显示会话流程
                            console.log("会话流程:");
                            sessionLogs.forEach((log, index) => {
                                console.log(`[${index + 1}] ${log.formattedTime} [${log.level}] ${log.type}: ${log.message}`);
                            });

                            // 专门展示QUERY_CHAT日志
                            console.log("\n===== Query Chat 日志 =====");
                            const queryChatLogs = sessionLogs.filter((log: any) => log.type === 'QUERY_CHAT');
                            if (queryChatLogs.length > 0) {
                                console.log(`找到 ${queryChatLogs.length} 条查询日志:`);
                                queryChatLogs.forEach((log, index) => {
                                    const attemptNumber = log.data?.attemptNumber || '未知';
                                    const code = log.data?.response?.code !== undefined ? log.data.response.code : '未知';
                                    const message = log.data?.response?.message || '无消息';
                                    console.log(`[${index + 1}] 第${attemptNumber}次查询 - 响应码: ${code}, 消息: ${message}`);

                                    // 如果是最后一次查询且是会话结束，显示结束信息
                                    if (log.data?.response?.finalQuery) {
                                        console.log(`  这是会话的最终查询，会话结束`);
                                    }
                                });

                                // 显示最后一次查询的完整响应
                                const lastQuery = queryChatLogs[queryChatLogs.length - 1];
                                console.log("\n最后一次查询的完整响应:");
                                console.log(lastQuery.data?.response || "无响应数据");
                            } else {
                                console.log("未找到任何query_chat日志");
                            }
                        }

                        // 获取所有日志（扁平化）
                        const allLogs = await aiLogger.getUserLogs(peerId);
                        console.log(`===== 用户所有日志 =====`);
                        console.log(`总日志数: ${allLogs.length}`);

                        // 检查旧格式日志
                        const relevantKeys = keys.filter(key => key.includes(peerId.toString()));
                        console.log(`与用户ID ${peerId} 相关的键:`, relevantKeys);

                        for (const key of relevantKeys) {
                            try {
                                const data = await storage.get(key);
                                if (data) {
                                    // 检查数据结构，判断是新格式还是旧格式
                                    if (Array.isArray(data)) {
                                        console.log(`键 "${key}" 包含 ${data.length} 条旧格式日志`);
                                    } else if (typeof data === 'object') {
                                        const sessionCount = Object.keys(data).length;
                                        console.log(`键 "${key}" 包含 ${sessionCount} 个会话（新格式）`);

                                        // 输出每个会话的信息
                                        for (const sessionId in data) {
                                            const logs = (data as any)[sessionId];
                                            if (Array.isArray(logs)) {
                                                console.log(`  - 会话 ${sessionId}: ${logs.length} 条日志`);
                                            }
                                        }
                                    }
                                } else {
                                    console.log(`键 "${key}" 不包含数据`);
                                }
                            } catch (err) {
                                console.error(`获取键 "${key}" 的日志失败:`, err);
                            }
                        }
                    } catch (err) {
                        console.error(`获取用户 ${peerId} 日志失败:`, err);

                        // 尝试直接查看存储
                        try {
                            let fullName = "未知用户";
                            try {
                                fullName = await getFullNameByPeerId(peerId) || "未知用户";
                            } catch (nameErr) {
                                console.error("获取用户名失败:", nameErr);
                            }

                            // 尝试使用新的键格式直接查询
                            const key = `${peerId}_${fullName}`;
                            console.log(`尝试直接查询键: ${key}`);

                            const data = await storage.get(key);
                            console.log("直接查询结果:", data);
                        } catch (directErr) {
                            console.error("直接查询也失败:", directErr);
                        }
                    }
                }
            } catch (err) {
                console.error("获取日志键失败:", err);
            }
        } catch (err) {
            console.error("访问日志存储失败:", err);
        }

        console.log("==== AI日志系统检查结束 ====");
        return "检查完成";
    };

    // 尝试添加一条测试日志
    (window as any).addTestLog = async function (peerId: number) {
        try {
            // 通过aiLogger尝试
            try {
                // 生成随机会话ID
                const testSessionId = `test_session_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

                // 修改aiLogger的sessionId以便于测试
                (aiLogger as any).sessionId = testSessionId;

                // 添加测试日志
                aiLogger.logReceivedMessage(peerId, "这是一条测试用户消息", { test: true, type: "text" });
                setTimeout(() => {
                    aiLogger.logAiMessageSent(peerId, "这是一条测试AI回复", "text", { test: true });
                }, 100);
                setTimeout(() => {
                    aiLogger.logAiQueryResponse(peerId, { status: "success", message: "测试查询响应" });
                }, 200);

                console.log("通过aiLogger添加测试日志成功，会话ID:", testSessionId);
            } catch (err) {
                console.error("通过aiLogger添加测试日志失败:", err);
            }

            // 直接尝试
            try {
                const storage = new IDBStorage(DATABASE_STATE, 'aiLogs');

                // 创建一个测试会话ID
                const testSessionId = `direct_test_session_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

                // 创建日志项
                const testLog = {
                    timestamp: Date.now(),
                    formattedTime: new Date().toISOString(),
                    type: "TEST_LOG",
                    level: "INFO",
                    message: `这是一条直接添加的测试日志 ${Date.now()}`,
                    sessionId: testSessionId,
                    data: { test: true }
                };

                // 尝试获取用户名
                let fullName = "测试用户";
                try {
                    fullName = await getFullNameByPeerId(peerId) || "测试用户";
                } catch (nameErr) {
                    console.error("获取用户名失败:", nameErr);
                }

                // 使用新的键格式
                const key = `${peerId}_${fullName}`;
                console.log(`使用键: ${key} 和会话ID: ${testSessionId}`);

                // 获取现有数据
                const existingSessions = await storage.get(key) as any || {};

                // 创建新的会话日志数组
                if (!existingSessions[testSessionId]) {
                    existingSessions[testSessionId] = [];
                }

                // 添加测试日志
                existingSessions[testSessionId].push(testLog);

                // 保存数据
                await storage.save(key, existingSessions);
                console.log("直接添加测试日志成功");

                // 提示用户检查日志
                console.log(`
============================
测试日志已添加成功！请运行以下命令查看：
window.checkAiLogs(${peerId})
============================
`);
            } catch (err) {
                console.error("直接添加测试日志失败:", err);
            }

            return "测试完成";
        } catch (err) {
            console.error("测试过程中发生错误:", err);
            return "测试失败";
        }
    };

    // 测试query_chat日志功能
    (window as any).testQueryChatLogs = async function (peerId: number) {
        try {
            // 生成随机会话ID
            const testSessionId = `test_query_chat_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

            // 修改aiLogger的sessionId以便于测试
            (aiLogger as any).sessionId = testSessionId;

            // 模拟用户会话开始
            aiLogger.startSession(peerId, { testSession: true });
            console.log(`测试会话已开始，ID: ${testSessionId}`);

            // 模拟用户消息
            aiLogger.logReceivedMessage(peerId, "这是一条测试用户消息", { test: true, type: "text" });

            // 模拟多次query_chat查询
            const queryResponses = [
                { code: 0, message: "ai conversation in process......", data: null },
                { code: 0, message: "ai conversation in process......", data: { type: "thinking" } },
                { code: 0, message: "ai conversation in process......", data: { type: "MSG_TEXT", content: "我正在思考中..." } },
                { code: 200, message: "success", data: { type: "MSG_TEXT", content: "这是AI的最终回复" } }
            ];

            // 模拟多次查询的响应
            for (let i = 0; i < queryResponses.length; i++) {
                const attemptNumber = i + 1;
                const response = queryResponses[i];

                // 添加日志
                aiLogger.logQueryChat(peerId, response, attemptNumber);

                // 如果是最后一次查询，模拟发送消息
                if (i === queryResponses.length - 1) {
                    aiLogger.logAiMessageSent(peerId, response.data.content, "text", response);
                }

                // 添加延迟效果
                await new Promise(resolve => setTimeout(resolve, 200));
            }

            // 模拟会话结束
            aiLogger.endSession(peerId, {
                code: 200,
                message: "success",
                attemptNumber: queryResponses.length,
                finalQuery: true
            });

            console.log(`
============================
测试query_chat日志已添加成功！请运行以下命令查看：
window.checkAiLogs(${peerId})
============================
`);

            return "测试完成";
        } catch (err) {
            console.error("测试query_chat日志过程中发生错误:", err);
            return "测试失败";
        }
    };
}